module.exports = __webpack_public_path__ + "img/MSPNG1_Cover.735d5653.jpg";